import { history } from "../_helpers/history";

const api_url = process.env.REACT_APP_API_URL;

export const addProject = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    fetch(api_url + "api/project/update/" + id + "/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "PROJECT_FAIL", data: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: "ADD_PROJECT", project: res.data });
          console.log("project ke action mine", res.data);
          history.go(0);
          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({ type: "AUTHENTICATION_ERROR", data: res.data });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({ type: "PROJECT_FAIL", data: res.data });
          throw res.data;
        }
      });
  };
};
export const getProjects = () => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    fetch(api_url + "api/project/" + id + "/", { headers })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "PROJECT_FAIL", data: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: "FETCH_PROJECT", project: res.data });

          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({ type: "AUTHENTICATION_ERROR", data: res.data });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({ type: "PROJECT_FAIL", data: res.data });
          throw res.data;
        }
      });
  };
};
export const getProjectList = (type) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    fetch(api_url + "api/project/all_projects/?list_for=" + type, { headers })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "PROJECT_LIST_FAIL", data: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: "FETCH_PROJECT_LIST", list: res.data });

          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({ type: "AUTHENTICATION_ERROR", data: res.data });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({ type: "PROJECT_LIST_FAIL", data: res.data });
          throw res.data;
        }
      });
  };
};

/*export const getCSV = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    fetch(api_url + "api/v2/download_csv_report/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "CSV_FAIL", data: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: "GET_CSV", csv: res.data });

          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({ type: "AUTHENTICATION_ERROR", csv: res.data });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({ type: "CSV_FAIL", data: res.data });
          throw res.data;
        }
      });
  };
};*/

export const getCSV = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    fetch(api_url + "api/v2/download_csv_report/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "CSV_FAIL", data: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: "GET_CSV", csv: res.data });

          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({ type: "AUTHENTICATION_ERROR", csv: res.data });
          history.push("/login");
          throw res.data;
        } else if (res.status === 400) {
          // Handle 400 error here
          dispatch({ type: "CSV_ERROR", csv: res.data });
          throw res.data;
        } else {
          dispatch({ type: "CSV_FAIL", data: res.data });
          throw res.data;
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
  };
};

export const getLoss = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    fetch(api_url + "api/portfolio/loss&risk/" + id + "/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "CSV_FAIL", data: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: "GET_CSV", csv: res.data });

          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({ type: "AUTHENTICATION_ERROR", csv: res.data });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({ type: "CSV_FAIL", data: res.data });
          throw res.data;
        }
      });
  };
};

export const getSummary = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    fetch(api_url + "api/v2/summary_report/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "CSV_FAIL", data: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: "GET_CSV", csv: res.data });

          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({ type: "AUTHENTICATION_ERROR", csv: res.data });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({ type: "CSV_FAIL", data: res.data });
          throw res.data;
        }
      });
  };
};

export const deleteProject = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    fetch(api_url + "api/project/delete/" + id + "/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "PROJECT_FAIL", data: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 201) {
          dispatch({ type: "DELETE_PROJECT", project: res.data });
          history.go(0);
          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({ type: "AUTHENTICATION_ERROR", data: res.data });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({ type: "PROJECT_FAIL", data: res.data });
          throw res.data;
        }
      });
  };
};

export const shareProject = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    fetch(api_url + "api/v2/share_project/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "SHARE_FAIL", data: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 201) {
          dispatch({ type: "SHARE_PROJECT", project: res.data });
          history.go(0);
          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({ type: "AUTHENTICATION_ERROR", data: res.data });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({ type: "SHARE_FAIL", data: res.data });
          throw res.data;
        }
      });
  };
};

export const getInvoice = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    fetch(api_url + "api/invoice/financial/" + id + "/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "INVOICE_FAIL", data: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: "FETCH_INVOICE", invoice: res.data });

          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({ type: "AUTHENTICATION_ERROR", invoice: res.data });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({ type: "INVOICE_FAIL", data: res.data });
          throw res.data;
        }
      });
  };
};
export const getReport = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    fetch(api_url + "api/report/draft/get/" + id + "/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "REPORT_FAIL", data: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: "FETCH_REPORT", report: res.data });

          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({ type: "AUTHENTICATION_ERROR", report: res.data });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({ type: "REPORT_FAIL", data: res.data });
          throw res.data;
        }
      });
  };
};

export const addReport = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    fetch(api_url + "api/report/draft/" + id + "/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "REPORT_FAIL", data: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: "ADD_REPORT", report: res.data });
          history.go(0);
          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({ type: "AUTHENTICATION_ERROR", report: res.data });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({ type: "REPORT_FAIL", data: res.data });
          throw res.data;
        }
      });
  };
};
export const getDetailedReport = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    fetch(api_url + "api/report/variable_data/" + id + "/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "DETAILREPORT_FAIL", data: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: "FETCH_DETAILREPORT", detailreport: res.data });

          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({ type: "AUTHENTICATION_ERROR", detailreport: res.data });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({ type: "DETAILREPORT_FAIL", data: res.data });
          throw res.data;
        }
      });
  };
};
export const getWindReport = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    fetch(api_url + "api/report/wind_data/" + id + "/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "WINDREPORT_FAIL", data: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: "FETCH_WINDREPORT", windreport: res.data });

          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({ type: "AUTHENTICATION_ERROR", windreport: res.data });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({ type: "WINDREPORT_FAIL", data: res.data });
          throw res.data;
        }
      });
  };
};
export const getLossReport = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    fetch(api_url + "api/report/loss_data/" + id + "/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "LOSSREPORT_FAIL", data: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: "FETCH_LOSSREPORT", lossreport: res.data });

          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({ type: "AUTHENTICATION_ERROR", lossreport: res.data });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({ type: "LOSSREPORT_FAIL", data: res.data });
          throw res.data;
        }
      });
  };
};
export const getCountryWiseLossReport = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    fetch(api_url + "api/report/country_loss/" + id + "/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "COUNTRYWISELOSSREPORT_FAIL", data: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: "FETCH_COUNTRYWISELOSSREPORT",
            countrywiselossreport: res.data,
          });

          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({
            type: "AUTHENTICATION_ERROR",
            countrywiselossreport: res.data,
          });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({ type: "COUNTRYWISELOSSREPORT_FAIL", data: res.data });
          throw res.data;
        }
      });
  };
};

export const getOverallMap = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    fetch(api_url + "api/report/loss_map/" + id + "/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "OVERALLMAPIMAGE_FAIL", data: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: "FETCH_OVERALLMAPIMAGE",
            overallmapimage: res.data,
          });

          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({
            type: "AUTHENTICATION_ERROR",
            overallmapimage: res.data,
          });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({ type: "OVERALLMAPIMAGE_FAIL", data: res.data });
          throw res.data;
        }
      });
  };
};

export const getAssetMap = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    fetch(api_url + "api/dashboard/plot_map/" + id + "/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "ASSETMAPIMAGE_FAIL", data: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: "FETCH_ASSETMAPIMAGE",
            assetmapimage: res.data,
          });

          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({
            type: "AUTHENTICATION_ERROR",
            assetmapimage: res.data,
          });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({ type: "ASSETMAPIMAGE_FAIL", data: res.data });
          throw res.data;
        }
      });
  };
};

export const getTcfdReport = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    fetch(api_url + "api/report/report_data/" + id + "/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "TCFDREPORT_FAIL", data: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: "FETCH_TCFDREPORT", tcfd: res.data });

          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({ type: "AUTHENTICATION_ERROR", tcfd: res.data });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({ type: "TCFDREPORT_FAIL", data: res.data });
          throw res.data;
        }
      });
  };
};

export const getPptReport = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    fetch(api_url + "api/v2/generate_pdf_report/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "PPTREPORT_FAIL", data: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: "FETCH_PPTREPORT", ppt: res.data });

          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({ type: "AUTHENTICATION_ERROR", ppt: res.data });
          history.push("/login");

          throw res.data;
        } else {
          dispatch({ type: "PPTREPORT_FAIL", data: res.data });
          throw res.data;
        }
      });
  };
};

export const getInsurance = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    fetch(api_url + "api/report/insurance_loss/" + id + "/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "INSURANCE_FAIL", data: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: "FETCH_INSURANCE", insurance: res.data });

          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({ type: "AUTHENTICATION_ERROR", insurance: res.data });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({ type: "INSURANCE_FAIL", data: res.data });
          throw res.data;
        }
      });
  };
};

export const getSatelliteMap = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    fetch(api_url + "api/report/assets_map/" + id + "/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "ASSETMAP_FAIL", data: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: "FETCH_ASSETMAP", map: res.data });

          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({ type: "AUTHENTICATION_ERROR", map: res.data });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({ type: "ASSETMAP_FAIL", data: res.data });
          throw res.data;
        }
      });
  };
};

export const getMap = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    fetch(api_url + "api/dashboard/plot_mapbox/" + id + "/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "MAP_FAIL", data: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: "FETCH_MAP", overall_map: res.data });

          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({ type: "AUTHENTICATION_ERROR", overall_map: res.data });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({ type: "MAP_FAIL", data: res.data });
          throw res.data;
        }
      });
  };
};

export const Dropbox = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};

    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    fetch(api_url + "api/report/get_link/" + id + "/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "LINK_FAIL", data: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 201) {
          dispatch({ type: "FETCH_LINK", link: res.data });

          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({ type: "AUTHENTICATION_ERROR", link: res.data });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({ type: "LINK_FAIL", data: res.data });
          throw res.data;
        }
      });
  };
};

export const getTransitionProject = () => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }
    fetch(api_url + "api/report/get_carbon_project_list/" + id + "/", {
      headers,
      method: "GET",
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({
            type: "TRANSITION_PROJECT_FAIL",
            transition_project: res.data,
          });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: "TRANSITION_PROJECT",
            transition_project: res.data,
          });

          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({
            type: "AUTHENTICATION_ERROR",
            transition_project: res.data,
          });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({
            type: "TRANSITION_PROJECT_FAIL",
            transition_project: res.data,
          });
          throw res.data;
        }
      });
  };
};

export const getCarbonProject = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }
    fetch(api_url + "api/report/get_carbon_analysis/" + id + "/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({ type: "CARBON_PROJECT_FAIL", carbon_project: res.data });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: "CARBON_PROJECT", carbon_project: res.data });

          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({ type: "AUTHENTICATION_ERROR", carbon_project: res.data });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({ type: "CARBON_PROJECT_FAIL", carbon_project: res.data });
          throw res.data;
        }
      });
  };
};

export const getCarbonProjectData = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }
    fetch(api_url + "api/report/get_carbon_project_data/" + id + "/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({
            type: "GET_CARBON_PROJECT_FAIL",
            carbon_project_data: res.data,
          });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: "GET_CARBON_PROJECT",
            carbon_project_data: res.data,
          });

          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({
            type: "AUTHENTICATION_ERROR",
            carbon_project_data: res.data,
          });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({
            type: "GET_CARBON_PROJECT_FAIL",
            carbon_project_data: res.data,
          });
          throw res.data;
        }
      });
  };
};

export const deleteCarbonProject = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }
    fetch(api_url + "api/report/delete_carbon_analysis/" + id + "/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({
            type: "DELETE_CARBON_PROJECT_FAIL",
            delete_carbon_project_data: res.data,
          });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: "DELETE_CARBON_PROJECT",
            delete_carbon_project_data: res.data,
          });
          history.go(0);
          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({
            type: "AUTHENTICATION_ERROR",
            delete_carbon_project_data: res.data,
          });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({
            type: "DELETE_CARBON_PROJECT_FAIL",
            delete_carbon_project_data: res.data,
          });
          throw res.data;
        }
      });
  };
};

export const downloadCarbonProject = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }
    fetch(api_url + "api/report/get_carbon_analysis/" + id + "/download/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({
            type: "DOWNLOAD_CARBON_PROJECT_FAIL",
            downlaod_carbon_project_data: res.data,
          });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: "DOWNLOAD_CARBON_PROJECT",
            download_carbon_project_data: res.data,
          });
          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({
            type: "AUTHENTICATION_ERROR",
            download_carbon_project_data: res.data,
          });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({
            type: "DOWNLOAD_CARBON_PROJECT_FAIL",
            download_carbon_project_data: res.data,
          });
          throw res.data;
        }
      });
  };
};
export const updateFilter = (formdata) => {
  return (dispatch, getState) => {
    let headers = {};
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("user_id");
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }
    fetch(api_url + "api/project/update_default_filter/", {
      headers,
      method: "POST",
      body: formdata,
    })
      .then((res) => {
        if (res.status < 500) {
          return res.json().then((data) => {
            return { status: res.status, data };
          });
        } else {
          dispatch({
            type: "UPDATE_FILTER_FAIL",
            filter: res.data,
          });
          console.log("Server Error");
          throw res.data;
        }
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: "UPDATE_FILTER",
            filter: res.data,
          });
          return res.data;
        } else if (res.status === 401 || res.status === 403) {
          dispatch({
            type: "AUTHENTICATION_ERROR",
            filter: res.data,
          });
          history.push("/login");
          throw res.data;
        } else {
          dispatch({
            type: "UPDATE_FILTER_FAIL",
            filter: res.data,
          });
          throw res.data;
        }
      });
  };
};
